import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const LoadingLayoutStyled = styled(Stack)({
  height: '100%',
  flex: 1,
});
